import OServicesModalLabel from './o-services-modal-label'

export default OServicesModalLabel;